import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import { setModalContent, setModalOpen, setModalWindowOfferParams } from 'shared/redux/landingSlice';
import { selectIsModalOpen } from 'shared/selectors/landing/selectIsModalOpen';
import { IRow } from '../../repositories/mortgage-broker-calculator/entities/modal/Row';
import { selectModalWindowContent } from '../../selectors/landing';
import { IAuthorizeAndRedirectProps, useAuthorized } from '../useAuthorized';
import { selectModalWindowRedirectParams } from 'shared/selectors/landing/selectModalWindowOfferParams';

interface IUseCreditInfoModal {
  isModalOpen: boolean;
  handleModalClose: () => void;
  handleModalOpen: (content: IRow[], fillApplicationParams?: IAuthorizeAndRedirectProps) => void;
  modalContent?: IRow[] | null;
  handleFillApplicationClick: () => void;
}

export const useCreditInfoModal = (): IUseCreditInfoModal => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsModalOpen);
  const modalContent = useSelector(selectModalWindowContent);
  const { authorizeAndRedirect } = useAuthorized();
  const modalWindowOfferParams = useSelector(selectModalWindowRedirectParams);

  const handleModalClose = React.useCallback(() => {
    dispatch(setModalOpen(false));
    dispatch(setModalContent(null));
    dispatch(setModalWindowOfferParams(null));
  }, [dispatch]);

  const handleModalOpen = (content: IRow[], fillApplicationParams?: IAuthorizeAndRedirectProps) => {
    dispatch(setModalContent(content));
    dispatch(setModalOpen(true));

    if (fillApplicationParams) {
      dispatch(setModalWindowOfferParams(fillApplicationParams));
    }
  };

  const handleFillApplicationClick = () => {
    if (modalWindowOfferParams) {
      authorizeAndRedirect(modalWindowOfferParams);
    }
  };

  return {
    isModalOpen,
    handleModalClose,
    handleModalOpen,
    modalContent,
    handleFillApplicationClick,
  };
};
